import React from 'react';
import ReactDOM from 'react-dom';

module.exports = React.createClass({
    backdrop: function() {
        return <div ref="backdrop" className='modal-backdrop in'/>;
    },

    stopPropagation: function(o) {
        o.stopPropagation();
    },
    modal: function() {
        var style = {display: 'block', overflowY: 'auto'};
        return (
            <div
                className='modal in'
                tabIndex='-1'
                role='dialog'
                aria-hidden='false'
                ref='modal'
                style={style}
                onClick={HC_CloseModal}
            >
                <div className="modal-dialog modal-sm" style={this.props['data-style']} onClick={this.stopPropagation}>
                    <div className='modal-content'>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    },

    render: function() {
        return (
            <div>
                {this.backdrop()}
                {this.modal()}
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./modal.js